<template>
<!-- Hero Section -->
    <section class="hero">
        <h1>Your AI Assistant That Actually<br>Understands Your Business</h1>
        <p class="subtitle">Stop juggling admin tasks. Start growing your business. Save 10+ hours every week.</p>
        <a href="#waitlist" class="cta-button">Join the Waitlist</a>
        <p class="trust-line">🔒 Built for Entrepreneurs with big dreams. Your data stays secure and private.</p>
        
        <div class="hero-visual">
            <div class="demo-split">
                <!-- Operational Demo -->
                <div class="demo-card">
                    <h3>⚡ Handles Customer Inquiries</h3>
                    <div class="chat-mockup-gif">
                        <img src="../assets/images/pabu-chat-demo.gif" alt="Pabu handling customer inquiries" class="chat-demo-gif">
                    </div>
                </div>

                <!-- Strategic Demo -->
                <div class="demo-card">
                    <h3>🧠 Shows What's Working</h3>
                    <div class="dashboard-mockup">
                        <div class="metric-card">
                            <div class="label">This Month</div>
                            <div class="value">$4,800</div>
                            <div class="change">↑ 22% from last month</div>
                        </div>
                        <div class="metric-card">
                            <div class="label">Appointments</div>
                            <div class="value">32</div>
                            <div class="change">↑ 15% from last month</div>
                        </div>
                        <div class="insight-badge">💡 5 customers asked about our Special Chocolate Cake</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "HeroSection",
};
</script>

<style scoped>

</style>
